














































































































import { Component } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import Spinner from '@/components/Spinner/Spinner.vue';
import Button from '@/components/Controls/Button/Button.vue';
import SliderLabels from './SliderLabels.vue';
import { parallax } from './effects';
import { SwiperOptions } from './types';
import { BaseSlider } from './BaseSlider';
import './swiper.scss';

@Component({
    components: {
        SvgIcon,
        Spinner,
        Button,
        SliderLabels,
        Swiper: () =>
            import(
                /* webpackChunkName: "Swiper" */
                /* webpackMode: "lazy" */ 'vue-awesome-swiper'
            ).then(({ Swiper }) => Swiper),

        SwiperSlide: () =>
            import(
                /* webpackChunkName: "Swiper" */
                /* webpackMode: "lazy" */ 'vue-awesome-swiper'
            ).then(({ SwiperSlide }) => SwiperSlide),
    },
})
export default class DefaultSlider extends BaseSlider {
    /**
     *
     */
    public mounted() {
        const swiperOptionsDefault: SwiperOptions = {
            lazy: {
                loadPrevNext: true,
            },
            longSwipesRatio: 0.3,
            preloadImages: false,
            loop: false,
            speed: 500,
            grabCursor: true,
            spaceBetween: 20,
            pagination: {
                el: this.navigation,
                clickable: true,
                renderBullet: (_index: number, className: string) =>
                    `<button class="${className}"><span class="swiper-pagination-bullet__inner"/></button>`,
            },
        };

        if (this.parallax) {
            this.swiperOptions = { ...swiperOptionsDefault, ...parallax() };
        } else {
            this.swiperOptions = swiperOptionsDefault;
        }
    }
}
